// removed by extract-text-webpack-plugin
module.exports = {"base":"_1cYyd","spin":"_2vSSp","loadFill":"_3yBrI","green":"D9WLo","grey":"_3Bx86","white":"_2sVkl","xSmall":"LENuV","small":"_3GF6X","medium":"Ioceg","large":"_30Xti"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/Spinner.scss
// module id = 1872
// module chunks = 0